export default __webpack_public_path__ + "static/media/pipelines-cut.413f53c3.svg";